import { render, staticRenderFns } from "./layout.comprobante.consultar.vue?vue&type=template&id=8eaa5cd0&scoped=true&"
import script from "./layout.comprobante.consultar.vue?vue&type=script&lang=js&"
export * from "./layout.comprobante.consultar.vue?vue&type=script&lang=js&"
import style0 from "./layout.comprobante.consultar.vue?vue&type=style&index=0&id=8eaa5cd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../frontend-new/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8eaa5cd0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../frontend-new/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCol,VContainer,VDivider,VIcon,VRow})
